import { t } from "i18next";
import Joi from "joi";
import {
  MAX_TEXT_FIELD_SIZE,
  PHONE_REGEX,
  EMIRATEID_REGEX,
  LOCATION_LATITUDE_REGEX,
  LOCATION_LONGITUDE_REGEX,
  LG_TEXT_FIELD_SIZE,
  MD_TEXT_FIELD_SIZE,
  EMAIL_REGEX,
} from "src/resources/constant";

export const surveySchema = (surveyDetails: any) => {
  return Joi.object({
    propertyName: Joi.string()
      .required()
      .max(LG_TEXT_FIELD_SIZE)
      .messages({
        "string.empty": t("fieldISRequired", { field: t("propertyName") }),
        "any.required": t("fieldISRequired", { field: t("propertyName") }),
        "string.max": t("maxLengthValidation", {
          maxLength: LG_TEXT_FIELD_SIZE,
        }),
      }),
    emergencyContact1FirstName: Joi.string()
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("emergencyContact1FirstName"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("emergencyContact1FirstName"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
      }),
    emirateNumber: Joi.string()
      .required()
      .pattern(new RegExp(EMIRATEID_REGEX))
      .messages({
        "any.required": t("fieldISRequired", { field: t("emirateNumber") }),
        "string.empty": t("fieldISRequired", { field: t("emirateNumber") }),
        "string.pattern.base": t("emiratesIdPatternValidation"),
      }),

    surveyContactPersonFirstName: Joi.string()
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("surveyContactPersonFirstName"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("surveyContactPersonFirstName"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
      }),

    surveyContactPersonLastName: Joi.string()
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("surveyContactPersonLastName"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("surveyContactPersonLastName"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
      }),
    accountHolderEmailAddress: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .pattern(new RegExp(EMAIL_REGEX))
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("accountHolderEmailAddress"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("accountHolderEmailAddress"),
        }),
        "string.email": t("emailPatternValidation"),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
        "string.pattern.base": t("emailPatternValidation"),
      }),
    emirate: Joi.string()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("emirate") }),
        "string.empty": t("fieldISRequired", { field: t("emirate") }),
      }),

    address: Joi.string()
      .required()
      .max(LG_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", { field: t("address") }),
        "string.empty": t("fieldISRequired", { field: t("address") }),
        "string.max": t("maxLengthValidation", {
          maxLength: LG_TEXT_FIELD_SIZE,
        }),
      }),
    territory: Joi.string()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("territory") }),
        "string.empty": t("fieldISRequired", { field: t("territory") }),
      }),
    city: Joi.string()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("city") }),
        "string.empty": t("fieldISRequired", { field: t("city") }),
      }),
    longitude: Joi.string()
      .pattern(new RegExp(LOCATION_LONGITUDE_REGEX))
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("longitude") }),
        "string.empty": t("fieldISRequired", { field: t("longitude") }),
        "string.pattern.base": t("longitudePatternValidation"),
      }),
    latitude: Joi.string()
      .pattern(new RegExp(LOCATION_LATITUDE_REGEX))
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("latitude") }),
        "string.empty": t("fieldISRequired", { field: t("latitude") }),
        "string.pattern.base": t("latitudePatternValidation"),
      }),

    accountHolderMobileNumber: Joi.string()
      .pattern(new RegExp(PHONE_REGEX))
      .optional()
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("accountHolderMobileNumber"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("accountHolderMobileNumber"),
        }),
        "string.pattern.base": `${t("mobileNumberPatternValidation")}`,
      }),
    accountHolderFirstName: Joi.string()
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("accountHolderFirstName"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("accountHolderFirstName"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
      }),
    accountHolderLastName: Joi.string()
      .required()
      .max(MD_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("accountHolderLastName"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("accountHolderLastName"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MD_TEXT_FIELD_SIZE,
        }),
      }),
    surveyContactPersonMobileNumber: Joi.string()
      .pattern(new RegExp(PHONE_REGEX))
      .required()
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("surveyContactPersonMobileNumber"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("surveyContactPersonMobileNumber"),
        }),
        "string.pattern.base": `${t("mobileNumberPatternValidation")}`,
      }),
    emergencyContact1MobileNumber: Joi.string()
      .pattern(new RegExp(PHONE_REGEX))
      .required()
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("emergencyContact1MobileNumber"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("emergencyContact1MobileNumber"),
        }),
        "string.pattern.base":`${t("mobileNumberPatternValidation")}`,
      }),
  });
};
